export function offerSearchTextMetro({ metro }: {
    metro?: {
        title: string;
        displayName?: string;
    };
}) {
    return metro ? `у метро ${ metro.displayName || metro.title }` : '';
}
